import { Combobox } from './combobox';
import './combobox.css';
import './range-combobox.css';

/**
 * RangeCombobox component - pair of comboboxes for from/to range filters
 * Used for price, year, mileage range filters
 *
 * @param {string} variant - 'default' | 'joined'
 *   - 'default': two separate inputs with dash between
 *   - 'joined': inputs appear as one continuous field with divider
 */
const RangeCombobox = ({
  id,
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  fromOptions = [],
  toOptions = [],
  fromPlaceholder = 'From',
  toPlaceholder = 'To',
  formatOption,
  prefix,
  className = '',
  inputWidth = 'range-combobox__field',
  variant = 'joined',
}) => {
  if (variant === 'joined') {
    return (
      <div
        className={`range-combobox range-combobox--joined ${className}`.trim()}
        onTouchStart={(e) => e.stopPropagation()}
      >
        <Combobox
          id={`${id}-from`}
          placeholder={fromPlaceholder}
          value={fromValue}
          onChange={onFromChange}
          options={fromOptions}
          formatOption={formatOption}
          prefix={prefix}
          inputClassName={inputWidth}
          variant="joined-left"
        />
        <div className="range-combobox__divider" />
        <Combobox
          id={`${id}-to`}
          placeholder={toPlaceholder}
          value={toValue}
          onChange={onToChange}
          options={toOptions}
          formatOption={formatOption}
          prefix={prefix}
          inputClassName={inputWidth}
          variant="joined-right"
        />
      </div>
    );
  }

  // Default variant with dash separator
  return (
    <div className={`range-combobox range-combobox--split ${className}`.trim()}>
      <Combobox
        id={`${id}-from`}
        placeholder={fromPlaceholder}
        value={fromValue}
        onChange={onFromChange}
        options={fromOptions}
        formatOption={formatOption}
        prefix={prefix}
        inputClassName={inputWidth}
      />
      <span className="range-combobox__dash">—</span>
      <Combobox
        id={`${id}-to`}
        placeholder={toPlaceholder}
        value={toValue}
        onChange={onToChange}
        options={toOptions}
        formatOption={formatOption}
        prefix={prefix}
        inputClassName={inputWidth}
      />
    </div>
  );
};

export { RangeCombobox };
export default RangeCombobox;
